import { render, staticRenderFns } from "./tab-records.vue?vue&type=template&id=558a40f8&scoped=true"
import script from "./tab-records.vue?vue&type=script&lang=js"
export * from "./tab-records.vue?vue&type=script&lang=js"
import style0 from "./tab-records.vue?vue&type=style&index=0&id=558a40f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558a40f8",
  null
  
)

export default component.exports